import React from "react"
import { Box, Typography, Grid } from "src/UILibrary"
import { useMediaQuery } from "react-responsive"
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined"
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined"
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined"
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined"
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined"
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined"
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined"
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined"
import LocalActivityOutlinedIcon from "@mui/icons-material/LocalActivityOutlined"
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks"
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd"
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined"
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined"
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined"
import ThreePOutlinedIcon from "@mui/icons-material/ThreePOutlined"
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined"
import AddAlertOutlinedIcon from "@mui/icons-material/AddAlertOutlined"
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined"
import AccessAlarmOutlinedIcon from "@mui/icons-material/AccessAlarmOutlined"
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined"
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined"
import DoDisturbAltOutlinedIcon from "@mui/icons-material/DoDisturbAltOutlined"
import KeyboardReturnOutlinedIcon from "@mui/icons-material/KeyboardReturnOutlined"
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined"
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined"
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined"
import AddchartOutlinedIcon from "@mui/icons-material/AddchartOutlined"
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined"
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined"
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined"
import DomainAddOutlinedIcon from "@mui/icons-material/DomainAddOutlined"
import AddIcCallOutlinedIcon from "@mui/icons-material/AddIcCallOutlined"
import AddToQueueOutlinedIcon from "@mui/icons-material/AddToQueueOutlined"

import { MEMBER_TYPE } from "src/modules/const"
import { useLoginContext } from "src/hooks/useLoginContext"

interface Props {
  title: string
  icon?: string
  active?: boolean
  index?: number
  onClick?: any
  subcount?: number
}
export const SubMenuItem = ({ title, icon, active, index, onClick, subcount }: Props) => {
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  const { userType } = useLoginContext()

  return isTablet ? (
    <Box
      sx={{
        mt: "0px",
        mx: "0px",
        p: "10px 20px",
        bgcolor: active ? "#FAFAFA" : "#F1F1F1",
        ":hover": { bgcolor: "#FAFAFA", cursor: "pointer" },
      }}
      onClick={() => {
        index !== undefined && onClick && onClick(index)
      }}
    >
      <Typography.SubTitle
        className="notosans weight500"
        sx={{ mt: "0px", maxHeight: "24px" }}
        color="textPrimary"
        fontSize={14}
      >
        {title}
      </Typography.SubTitle>
    </Box>
  ) : (
    <Grid
      item
      lg={12 / (subcount ? subcount : 7)}
      md={12 / (subcount ? subcount : 7)}
      sm={12 / (subcount ? subcount : 7)}
      xs={12 / (subcount ? subcount : 7)}
      sx={{
        textAlign: "center",
        p: "0px",
        m: "0px",
        bgcolor: active ? "#FAFAFA" : "#F1F1F1",
        borderTop: active ? "2px solid #1F6757" : "",
        ":hover": { bgcolor: "#FAFAFA", cursor: "pointer" },
      }}
      onClick={() => {
        index !== undefined && onClick && onClick(index)
      }}
    >
      {
        <Box sx={{ mt: "10px" }}>
          {icon == "inbox" ? <FileDownloadOutlinedIcon /> : <></>}
          {icon == "favorite_video" ? <VideocamOutlinedIcon /> : <></>}
          {icon == "job_information" ? <MessageOutlinedIcon /> : <></>}
          {icon == "register_information" ? <PersonOutlineOutlinedIcon /> : <></>}
          {icon == "contact" ? <EmailOutlinedIcon /> : <></>}
          {icon == "reservation_manage" ? <DriveFileRenameOutlineOutlinedIcon /> : <></>}
          {icon == "event_manage" ? <PlayArrowOutlinedIcon /> : <></>}
          {icon == "user_manage" ? <BookmarkBorderOutlinedIcon /> : <></>}
          {icon == "notification_manage" ? <CampaignOutlinedIcon /> : <></>}

          {icon == "consult" ? <HeadsetMicOutlinedIcon /> : <></>}
          {icon == "event" ? <LocalActivityOutlinedIcon /> : <></>}
          {icon == "all" ? <PlaylistAddCheckOutlinedIcon /> : <></>}

          {icon == "books" ? <LibraryBooksIcon /> : <></>}
          {icon == "new_book" ? <BookmarkAddIcon /> : <></>}

          {icon == "register_information_change" ? <ManageAccountsOutlinedIcon /> : <></>}
          {icon == "password_change" ? <KeyOutlinedIcon /> : <></>}

          {icon == "news" ? <TextsmsOutlinedIcon /> : <></>}
          {icon == "interview" ? <ThreePOutlinedIcon /> : <></>}
          {icon == "new_notification" ? <AddAlertOutlinedIcon /> : <></>}

          {icon == "consult_list" ? <ReceiptLongOutlinedIcon /> : <></>}
          {icon == "consult_in_progress" ? <AccessAlarmOutlinedIcon /> : <></>}
          {icon == "consult_confirmation" ? <DoneAllOutlinedIcon /> : <></>}
          {icon == "cancel" ? <CancelOutlinedIcon /> : <></>}
          {icon == "resignation" ? <DoDisturbAltOutlinedIcon /> : <></>}

          {icon == "event_list_receiving" ? <ExploreOutlinedIcon /> : <></>}
          {icon == "return" ? <KeyboardReturnOutlinedIcon /> : <></>}
          {icon == "archive" ? <SaveOutlinedIcon /> : <></>}
          {icon == "draft" ? <DraftsOutlinedIcon /> : <></>}
          {icon == "event_new" ? <AddchartOutlinedIcon /> : <></>}

          {icon == "adviser" ? <RecordVoiceOverOutlinedIcon /> : <></>}
          {icon == "company" ? <BusinessOutlinedIcon /> : <></>}
          {icon == "new_user" ? <PersonAddAltOutlinedIcon /> : <></>}
          {icon == "new_adviser" ? <AddIcCallOutlinedIcon /> : <></>}
          {icon == "new_company" ? <DomainAddOutlinedIcon /> : <></>}
          {icon == "new_administrator" ? <AddToQueueOutlinedIcon /> : <></>}
        </Box>
      }

      {userType == MEMBER_TYPE.ADMINISTRATOR ? (
        <Typography.SubTitle
          className="notosans weight700 submenu-admin"
          color="textPrimary"
          sx={{ mt: "-6px" }}
        >
          {title}
        </Typography.SubTitle>
      ) : (
        <Typography.SubTitle
          className="notosans weight700 submenu"
          color="textPrimary"
          sx={{ mt: "-6px" }}
        >
          {title}
        </Typography.SubTitle>
      )}
    </Grid>
  )
}
